import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { Customer } from '../Customer'
import type { IAction } from '../../action/IAction'

@InputType()
export class UpdateRelatedToCustomerArgs extends ActionArgs {
  @Field(() => Customer)
  customer: Customer
}

export interface IUpdateRelatedToCustomer extends IAction<void, UpdateRelatedToCustomerArgs> {}
